var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListingsDirectoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5V3.75C5 1.67891 6.64453 0 8.75 0C10.8203 0 12.5 1.67891 12.5 3.75V5H15.625C16.6602 5 17.5 5.83984 17.5 6.875V16.25C17.5 18.3203 15.8203 20 13.75 20H3.75C1.67891 20 0 18.3203 0 16.25V6.875C0 5.83984 0.839453 5 1.875 5H5ZM6.25 5H11.25V3.75C11.25 2.36914 10.1289 1.25 8.75 1.25C7.37109 1.25 6.25 2.36914 6.25 3.75V5ZM1.875 6.25C1.52969 6.25 1.25 6.53125 1.25 6.875V16.25C1.25 17.6289 2.36914 18.75 3.75 18.75H13.75C15.1289 18.75 16.25 17.6289 16.25 16.25V6.875C16.25 6.53125 15.9688 6.25 15.625 6.25H12.5V9.375C12.5 9.71875 12.2188 10 11.875 10C11.5312 10 11.25 9.71875 11.25 9.375V6.25H6.25V9.375C6.25 9.71875 5.96875 10 5.625 10C5.28125 10 5 9.71875 5 9.375V6.25H1.875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingsDirectoryIcon);
export default __webpack_public_path__ + "static/media/listings_directory_icon.3335d897ea1e3dbec3b004602c7c13c6.svg";
export { ForwardRef as ReactComponent };